import { InvoiceEmailForm } from './InvoiceEmail/EmailForm';
import { useAppSelector } from 'src/app/store/hooks';
import type { ModalProps } from 'src/common/primitives/Modal';
import { Modal } from 'src/common/primitives/Modal';

export function InvoiceEmailModal({
  open,
  setOpen,
}: Pick<ModalProps, 'open' | 'setOpen'>) {
  const editingInvoice = useAppSelector(
    (state) => state.invoice.editingInvoice
  );

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      contentClassnames="max-w-[30vw]"
      title="Send Invoice Email"
    >
      <h3 className="pb-2 text-[24px] font-medium leading-6 text-gray-900">
        Send Invoice Email
      </h3>
      {editingInvoice && (
        <InvoiceEmailForm
          invoice={editingInvoice}
          invoiceNumber={editingInvoice.number}
          onClose={() => setOpen(false)}
        />
      )}
    </Modal>
  );
}
